 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		123: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		123: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"29":"menuDe","30":"menuEn","31":"menuEs","32":"menuFr","33":"styles","124":"staticTextDe","125":"staticTextES","126":"staticTextEn","127":"staticTextEs","128":"staticTextFr","129":"videojsplugins"}[chunkId]||chunkId) + "." + {"0":"942fa8f02d6700be1acd","1":"f9458e1fec3d3e99c67e","2":"22541343a50624f708f4","3":"23c5da981bd4108e6e72","4":"2a4c8415b41a1a862901","5":"44ca60fe48aadc9a589e","6":"ccdbb213bca37aea222c","7":"11e63a8987b1ff3134ed","8":"0bc2ebfee92e605c7dd7","9":"c297ba477c768bc132c4","10":"5f0ad55c44fb83dd8bf9","11":"2f3b2a29a56c146be089","12":"f3e1691e5a4c22d292cc","13":"e18ac7d7cc035dea5804","14":"3fd1b55866eb92770416","15":"761bc2104591492015fe","16":"7776f49a4df179e6ae45","17":"b7f00ba2b706a50af327","18":"be146ea833f1f20b3c0b","19":"02d38b70baadb6f929b5","20":"44d3ce1554fccc4575ed","21":"f8e8c9a75efac06c917a","22":"a8ca5db553857c3881f4","23":"1c5908ff746e8c1005b1","24":"3641a5f1314f6b6bb4dd","25":"8bc16fa759c76cd266a1","26":"3505aba1898851ce7e64","27":"c0bd3d32f0ce26ba5369","28":"defad2cf0127fb190c7e","29":"7a35ebdb2e513813d8d3","30":"403ee070b7645c5325fa","31":"39da6ab0b9f253521e2c","32":"74ee9b5c3c6d56b9f0bf","33":"e925de44e7f7d52dd906","34":"a7913f25fbf8cb046027","35":"73d2893fbe03fa8c7423","36":"e62418855906ecd77b3a","37":"e9b8a25e6815d0406ac7","38":"a9792770b2b70c2a8752","39":"dfa6fc61fee70e6bdc99","40":"ccfcc1ec9ff01b7595fe","41":"9ad19db8e8a9839fafde","42":"d6b622eb873b7c6bc3cb","43":"224d9be2a1f10b58e6d5","44":"17366e71ca1e77198a78","45":"3627e23fb18be6a3ece5","46":"c0858bbc2e021536c694","47":"68c8ee097ba7cfde6e8d","48":"c13aefe3d97a49c60432","49":"cd435a5db520a143d954","50":"7bacca1d83e195e9a4ea","51":"a90df3cc041e079817d9","52":"be498fefde09dbfc1624","53":"5e5860b80992c980a37f","54":"7e85b07a441a6985787e","55":"a3ecced3c7ad18ddcf16","56":"f628fb0927a766dc9b5b","57":"bdd5061dd1d0cd92bcc0","58":"9a9707fa48a6c6a7d00c","59":"177a4810756bc2f51d32","60":"3710853a9d0600ab54c1","61":"c13437fdad48416bc0cf","62":"ce695c0277f9b51e2b3d","63":"72524d85d99f9bbe10df","64":"2d42623cb6a1059eeacd","65":"c2143367f93b193f687f","66":"a52eea0674fa74d99786","67":"56543470d0b00917c773","68":"bfe58d543501e50dc755","69":"bbe91ecb1bbf870e92bd","70":"570da194774b930f2fec","71":"92ff0357a80dc2f63453","72":"ed55d5cfa82b32d4be4f","73":"4b4c0f736bcf8583e5da","74":"e332757a9dc8d07f5e0f","75":"15e7faffd53fd9256049","76":"83d96eb5f35ac5f8e447","77":"73dca0e451a38a34e061","78":"0be507daf29dda9d0b2c","79":"432782f310f44e5bd985","80":"86876549ccb5db589596","81":"984035130b7f29035910","82":"9ad446183e595bd31f66","83":"1512d81c803f25c69497","84":"4974ee3d2ff604216dae","85":"533598622f89c0f1e0d7","86":"6d5be459cdad205af0c2","87":"bd785ebcebffa6c604a0","88":"a7787e31450c755c858a","89":"181e9fdd8cf65acebc75","90":"aad6f593d2adb2d81f16","91":"bd6135bd72aaf8ed2174","92":"fb79656d024a99114306","93":"d1237d932df595644f33","94":"5f8c0b2e0333ac27f06c","95":"75e3155899d8b705870c","96":"d78753bb804797e1bfdc","97":"2d67e109de2a485861a5","98":"fe110d50b635f1bd2292","99":"e5ed9439708a7a4af0bc","100":"3370c2586df4f477cb6b","101":"aa05a18b607a0f98275b","102":"95648e196f481c0ce26f","103":"e6312c28b06159665e67","104":"d3489dc70767f033b6a3","105":"581c415eba1c564f20cf","106":"b84ac873e774c2cc0070","107":"38a0177e88c13d443a42","108":"4f6b2595f24bb5280dd3","109":"101fdc344f7c761c927d","110":"ea6f069fc53341225204","111":"24ed1ce1807c7058af66","112":"b2f899ffb084fd06e81c","113":"c3f5db973fc1df42576c","114":"09924434bc62c819a6ea","115":"b6078839ea0fed4742cb","116":"c887ba588f3bb88ef449","117":"6437380e27f435ea171c","118":"3525ccc932887fa7676f","119":"f24f48983e822078e2b0","120":"8d6a8d8d8ca1abee9b1b","121":"0d33179bdbeb0c8ce553","122":"8eb46ec3a19216032155","124":"3fc8459435000c807132","125":"04e446e55087ecdd9369","126":"79c9fc8d836abe604a48","127":"f9300153368dd326f4f6","128":"56e5bbb50467feab224f","129":"6beb462730e4332cb39d","130":"925d4f53be862e03bb4f","131":"41a27a59e1ebed00d0f8","132":"2f0e5b992d6ae6ef7531","133":"ab165e349fe8c3cd64b2","134":"3e17295492f02daa730d","135":"14d9861a78a594e436ef","136":"22d030a127b946993bca","137":"efa539c59caa122595af","138":"3e78417250da364c93f3","139":"da7ab1e06029560fe850"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"33":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"29":"menuDe","30":"menuEn","31":"menuEs","32":"menuFr","33":"styles","124":"staticTextDe","125":"staticTextES","126":"staticTextEn","127":"staticTextEs","128":"staticTextFr","129":"videojsplugins"}[chunkId]||chunkId) + "." + {"0":"942fa8f02d6700be1acd","1":"f9458e1fec3d3e99c67e","2":"22541343a50624f708f4","3":"23c5da981bd4108e6e72","4":"2a4c8415b41a1a862901","5":"44ca60fe48aadc9a589e","6":"ccdbb213bca37aea222c","7":"11e63a8987b1ff3134ed","8":"0bc2ebfee92e605c7dd7","9":"c297ba477c768bc132c4","10":"5f0ad55c44fb83dd8bf9","11":"2f3b2a29a56c146be089","12":"f3e1691e5a4c22d292cc","13":"e18ac7d7cc035dea5804","14":"3fd1b55866eb92770416","15":"761bc2104591492015fe","16":"7776f49a4df179e6ae45","17":"b7f00ba2b706a50af327","18":"be146ea833f1f20b3c0b","19":"02d38b70baadb6f929b5","20":"44d3ce1554fccc4575ed","21":"f8e8c9a75efac06c917a","22":"a8ca5db553857c3881f4","23":"1c5908ff746e8c1005b1","24":"3641a5f1314f6b6bb4dd","25":"8bc16fa759c76cd266a1","26":"3505aba1898851ce7e64","27":"c0bd3d32f0ce26ba5369","28":"defad2cf0127fb190c7e","29":"7a35ebdb2e513813d8d3","30":"403ee070b7645c5325fa","31":"39da6ab0b9f253521e2c","32":"74ee9b5c3c6d56b9f0bf","33":"e925de44e7f7d52dd906","34":"a7913f25fbf8cb046027","35":"73d2893fbe03fa8c7423","36":"e62418855906ecd77b3a","37":"e9b8a25e6815d0406ac7","38":"a9792770b2b70c2a8752","39":"dfa6fc61fee70e6bdc99","40":"ccfcc1ec9ff01b7595fe","41":"9ad19db8e8a9839fafde","42":"d6b622eb873b7c6bc3cb","43":"224d9be2a1f10b58e6d5","44":"17366e71ca1e77198a78","45":"3627e23fb18be6a3ece5","46":"c0858bbc2e021536c694","47":"68c8ee097ba7cfde6e8d","48":"c13aefe3d97a49c60432","49":"cd435a5db520a143d954","50":"7bacca1d83e195e9a4ea","51":"a90df3cc041e079817d9","52":"be498fefde09dbfc1624","53":"5e5860b80992c980a37f","54":"7e85b07a441a6985787e","55":"a3ecced3c7ad18ddcf16","56":"f628fb0927a766dc9b5b","57":"bdd5061dd1d0cd92bcc0","58":"9a9707fa48a6c6a7d00c","59":"177a4810756bc2f51d32","60":"3710853a9d0600ab54c1","61":"c13437fdad48416bc0cf","62":"ce695c0277f9b51e2b3d","63":"72524d85d99f9bbe10df","64":"2d42623cb6a1059eeacd","65":"c2143367f93b193f687f","66":"a52eea0674fa74d99786","67":"56543470d0b00917c773","68":"bfe58d543501e50dc755","69":"bbe91ecb1bbf870e92bd","70":"570da194774b930f2fec","71":"92ff0357a80dc2f63453","72":"ed55d5cfa82b32d4be4f","73":"4b4c0f736bcf8583e5da","74":"e332757a9dc8d07f5e0f","75":"15e7faffd53fd9256049","76":"83d96eb5f35ac5f8e447","77":"73dca0e451a38a34e061","78":"0be507daf29dda9d0b2c","79":"432782f310f44e5bd985","80":"86876549ccb5db589596","81":"984035130b7f29035910","82":"9ad446183e595bd31f66","83":"1512d81c803f25c69497","84":"4974ee3d2ff604216dae","85":"533598622f89c0f1e0d7","86":"6d5be459cdad205af0c2","87":"bd785ebcebffa6c604a0","88":"a7787e31450c755c858a","89":"181e9fdd8cf65acebc75","90":"aad6f593d2adb2d81f16","91":"bd6135bd72aaf8ed2174","92":"fb79656d024a99114306","93":"d1237d932df595644f33","94":"5f8c0b2e0333ac27f06c","95":"75e3155899d8b705870c","96":"d78753bb804797e1bfdc","97":"2d67e109de2a485861a5","98":"fe110d50b635f1bd2292","99":"e5ed9439708a7a4af0bc","100":"3370c2586df4f477cb6b","101":"aa05a18b607a0f98275b","102":"95648e196f481c0ce26f","103":"e6312c28b06159665e67","104":"d3489dc70767f033b6a3","105":"581c415eba1c564f20cf","106":"b84ac873e774c2cc0070","107":"38a0177e88c13d443a42","108":"4f6b2595f24bb5280dd3","109":"101fdc344f7c761c927d","110":"ea6f069fc53341225204","111":"24ed1ce1807c7058af66","112":"b2f899ffb084fd06e81c","113":"c3f5db973fc1df42576c","114":"09924434bc62c819a6ea","115":"b6078839ea0fed4742cb","116":"c887ba588f3bb88ef449","117":"6437380e27f435ea171c","118":"3525ccc932887fa7676f","119":"f24f48983e822078e2b0","120":"8d6a8d8d8ca1abee9b1b","121":"0d33179bdbeb0c8ce553","122":"8eb46ec3a19216032155","124":"3fc8459435000c807132","125":"04e446e55087ecdd9369","126":"79c9fc8d836abe604a48","127":"f9300153368dd326f4f6","128":"56e5bbb50467feab224f","129":"6beb462730e4332cb39d","130":"925d4f53be862e03bb4f","131":"41a27a59e1ebed00d0f8","132":"2f0e5b992d6ae6ef7531","133":"ab165e349fe8c3cd64b2","134":"3e17295492f02daa730d","135":"14d9861a78a594e436ef","136":"22d030a127b946993bca","137":"efa539c59caa122595af","138":"3e78417250da364c93f3","139":"da7ab1e06029560fe850"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				(function insert(linkTag) {
 				      if (document.querySelector('#assets-main-stylesheet')) {
 				        return;
 				      }
 				      document.head.appendChild(linkTag);
 				    })(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 780);
